import request from '@/utils/request'

/**
 * 用户登录
 * @param {Object} data - 登录信息
 * @param {string} data.username - 用户名
 * @param {string} data.password - 密码
 * @param {string} data.captchaAnswer - 验证码答案
 * @returns {Promise<string>} 返回 token (新格式下从 Result.data 中获取)
 */
export function login(data) {
  return request({
    url: '/api/v1/admin/login',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

/**
 * 获取用户权限信息
 * @returns {Promise<Object>} 返回用户权限详情 (新格式下从 Result.data 中获取)
 */
export function getPermission() {
  return request({
    url: '/api/v1/admin/getPermission',
    method: 'get'
  })
}

/**
 * 用户登出（本地清除）
 */
export function logout() {
  // 这里可以调用后端登出接口，如果有的话
  return Promise.resolve()
}

/**
 * 小程序用户分页查询
 * @param {Object} params - 查询参数
 * @param {number} params.userId - 用户ID，精确匹配
 * @param {string} params.openId - 微信openId，精确匹配
 * @param {string} params.unionId - 微信unionId，精确匹配
 * @param {string} params.nickName - 用户昵称，模糊查询
 * @param {number} params.gender - 性别：0-未知，1-男，2-女
 * @param {number} params.phone - 电话号码，精确匹配
 * @param {string} params.email - 邮箱地址，模糊查询
 * @param {number} params.tenantId - 租户ID，精确匹配
 * @param {number} params.pageNum - 页码，从1开始，默认1
 * @param {number} params.pageSize - 每页记录数，默认20
 * @returns {Promise<Object>} 返回分页数据
 */
export function getMiniAppUserPage(params) {
  return request({
    url: '/api/v1/admin/user/page',
    method: 'get',
    params
  })
}

/**
 * 创建后台用户
 * @param {Object} data - 用户信息
 * @param {number} data.userId - 用户ID
 * @param {number} data.username - 登录账号
 * @param {string} data.password - 密码(明文,系统会自动MD5加密)
 * @param {number} data.tenantId - 所属组织ID
 * @param {number} data.state - 启用状态(0-禁用 1-启用,默认1)
 * @returns {Promise<Object>} 返回创建的用户信息
 */
export function createEhrUser(data) {
  return request({
    url: '/api/v1/admin/ehr-user',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

/**
 * 更新后台用户
 * @param {number} id - 用户主键ID
 * @param {Object} data - 用户信息
 * @param {number} data.username - 登录账号
 * @param {string} data.password - 密码(明文,系统会自动MD5加密)
 * @param {number} data.tenantId - 所属组织ID
 * @param {number} data.state - 启用状态(0-禁用 1-启用)
 * @returns {Promise<Object>} 返回更新后的用户信息
 */
export function updateEhrUser(id, data) {
  return request({
    url: `/api/v1/admin/ehr-user/${id}`,
    method: 'put',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

/**
 * 删除后台用户
 * @param {number} id - 用户主键ID
 * @returns {Promise<boolean>} 返回删除结果
 */
export function deleteEhrUser(id) {
  return request({
    url: `/api/v1/admin/ehr-user/${id}`,
    method: 'delete'
  })
}

/**
 * 修改密码
 * @param {string} password - 新密码
 * @returns {Promise<boolean>} 返回修改结果
 */
export function updatePassword(password) {
  return request({
    url: '/api/v1/admin/ehr-user/password',
    method: 'put',
    data: {
      password
    }
  })
}

/**
 * 查询单个后台用户
 * @param {number} id - 用户主键ID
 * @returns {Promise<Object>} 返回用户信息
 */
export function getEhrUser(id) {
  return request({
    url: `/api/v1/admin/ehr-user/${id}`,
    method: 'get'
  })
}

/**
 * 分页查询后台用户列表
 * @param {Object} params - 查询参数
 * @param {number} params.id - 主键ID(精确查询)
 * @param {number} params.userId - 用户ID(精确查询)
 * @param {number} params.username - 登录账号(精确查询)
 * @param {number} params.tenantId - 所属组织ID(精确查询)
 * @param {number} params.state - 启用状态(0-禁用 1-启用)
 * @param {number} params.status - 状态(0-无效 1-有效,默认查询有效用户)
 * @param {number} params.ctimeStart - 创建开始时间（时间戳，毫秒）
 * @param {number} params.ctimeEnd - 创建结束时间（时间戳，毫秒）
 * @param {number} params.pageNum - 页码(默认1)
 * @param {number} params.pageSize - 每页大小(默认20)
 * @returns {Promise<Object>} 返回分页数据
 */
export function getEhrUserPage(params) {
  return request({
    url: '/api/v1/admin/ehr-user/page',
    method: 'get',
    params
  })
}





